<template>
  <button @click.stop="toggleComparison"
          :disabled="!canAddMore && !isInComparison"
          :class="buttonClass"
          class="btn btn-sm transition-all duration-200"
          :title="tooltipText">
    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" 
            d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z"/>
    </svg>
    <span v-if="showText" class="ml-1">
      {{ isInComparison ? 'Quitar' : 'Comparar' }}
    </span>
  </button>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ComparisonButton',
  props: {
    property: {
      type: Object,
      required: true
    },
    showText: {
      type: Boolean,
      default: true
    },
    size: {
      type: String,
      default: 'sm',
      validator: value => ['xs', 'sm', 'md', 'lg'].includes(value)
    }
  },
  computed: {
    ...mapGetters('comparison', [
      'canAddMore',
      'isInComparison',
      'comparisonCount',
      'maxComparison'
    ]),
    
    isPropertyInComparison() {
      return this.isInComparison(this.property.id);
    },
    
    buttonClass() {
      if (this.isPropertyInComparison) {
        return 'btn-warning hover:btn-error';
      } else if (this.canAddMore) {
        return 'btn-outline btn-primary hover:btn-primary';
      } else {
        return 'btn-disabled opacity-50';
      }
    },
    
    tooltipText() {
      if (this.isPropertyInComparison) {
        return 'Quitar de la comparación';
      } else if (this.canAddMore) {
        return 'Agregar a comparación';
      } else {
        return `Máximo ${this.maxComparison} propiedades para comparar`;
      }
    }
  },
  
  methods: {
    ...mapActions('comparison', [
      'addToComparison',
      'removeFromComparison'
    ]),
    
    async toggleComparison() {
      try {
        if (this.isPropertyInComparison) {
          await this.removeFromComparison(this.property.id);
          this.showToast('Propiedad removida de la comparación', 'info');
        } else if (this.canAddMore) {
          await this.addToComparison(this.property);
          this.showToast('Propiedad agregada a la comparación', 'success');
        }
      } catch (error) {
        this.showToast(error.message, 'error');
      }
    },
    
    showToast(message, type = 'info') {
      // Simple toast notification - you could integrate with a toast library here
      const event = new CustomEvent('show-toast', {
        detail: { message, type }
      });
      window.dispatchEvent(event);
    }
  }
}
</script>

<style scoped>
.btn:disabled {
  cursor: not-allowed;
}
</style>
